import React from "react";
import { MessageSquareOff } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import type DncEntry from "@/model/interface/DncEntry";
import { formatDateTime } from "@/util/date";

interface DoNotTextNoticeProps {
  blockingEntry: DncEntry | null;
  showNumber?: boolean;
  className?: string;
}

export default function DoNotTextNotice({ blockingEntry, showNumber = false, className }: DoNotTextNoticeProps) {
  function headline(entry: DncEntry) {
    const target = showNumber ? entry.phoneNumberE164 : "this number";
    return entry.type === "DNT" ? `Texting is off for ${target}.` : `Texts and calls are off for ${target}.`;
  }

  function reason(entry: DncEntry) {
    const addedOn = formatDateTime(entry.createdAt);
    if (entry.source === "LITIGATOR") {
      return "Known litigator.";
    }
    if (entry.source === "OPT_OUT") {
      return entry.type === "DNT"
        ? `They opted out by text reply on ${addedOn}.`
        : `They asked not to be called on ${addedOn}.`;
    }
    const user = entry.createdByMembership?.user;
    const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");
    return name ? `Added by ${name} on ${addedOn}.` : `Added on ${addedOn}.`;
  }

  if (!blockingEntry) {
    return null;
  }

  return (
    <Alert className={className}>
      <MessageSquareOff className="h-4 w-4" />
      <AlertDescription>
        <span className="font-semibold">{headline(blockingEntry)}</span> {reason(blockingEntry)}
      </AlertDescription>
    </Alert>
  );
}
